import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";
import { IS_BRANCH_PORTAL } from "../../branch/tenant";

interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    m_email: string | null;
    m_mobile: string | null;
    m_id: string | null;
    m_level: number | null;
    m_name: string | null;
    member_idx: number | null;
    customer_idx: number | null;
    setAuth: (data: Partial<AuthState>) => void;
    clearAuth: () => void;
    logout: () => void;
}

const customStorage: PersistStorage<AuthState> = {
    getItem: name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    },
    setItem: (name, value) => {
        localStorage.setItem(name, JSON.stringify(value));
    },
    removeItem: name => {
        localStorage.removeItem(name);
    },
};

export const useAuthStore = create(
    persist<AuthState>(
        set => ({
            accessToken: null,
            refreshToken: null,
            m_email: null,
            m_mobile: null,
            m_id: null,
            m_level: null,
            m_name: null,
            member_idx: null,
            customer_idx: null,
            logout: () => {
                set({ accessToken: null, refreshToken: null });
            },
            setAuth: data => set(state => ({ ...state, ...data })),
            clearAuth: () =>
                set({
                    accessToken: null,
                    refreshToken: null,
                    m_email: null,
                    m_mobile: null,
                    m_id: null,
                    m_level: null,
                    m_name: null,
                    member_idx: null,
                    customer_idx: null,
                }),
        }),
        {
            // 지점 포털(/branch)은 별도 키를 써서 본점 콘솔과 세션이 섞이지 않게 한다
            name: IS_BRANCH_PORTAL ? "branch-auth-storage" : "auth-storage",
            storage: customStorage,
        },
    ),
);
